// tslint:disable:no-string-literal

/**
 * This helper should be used where ever we want an instance of FileReader. There is some strange behaviour caused
 * by Polyfills and Cordova, which both try to patch and wrap FileReader.
 *
 * This helper will, depending on whether we're running on mobile or desktop, return the original FileReader which
 * should excludes the craziness added by Polyfill and Cordova.
 */
export class FileReaderHelper {

    static getFileReader(): FileReader {
        let reader: FileReader;
        reader = new FileReader();

        // return the FileReader for mobile @todo we should check if we are in mobile context
        if (reader['__zone_symbol__originalInstance']) {
            reader = reader['__zone_symbol__originalInstance'];
        }

        //
        // // return the FileReader for browser
        // if (reader['_realReader']) {
        //     reader = reader['_realReader'];
        // }
        //


        return reader;
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/file-system/file-reader.helper.ts